import { gql } from "@apollo/client";

export const CREATE_MODULE = gql`
  mutation CreateModule($input: ModuleCreateInput!) {
    moduleCreate(input: $input) {
      id
    }
  }
`;
